<template>
  <div>
    Brüt Kar
    <ul>
      <li>
        Marka Bazlı Brüt Kar
      </li>
      <li>
        - Geçmiş Dönem Kar ₺
      </li>
      <li>
        - Geçmiş dönem ile değişim oranı %
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'GrossProfit',
}
</script>
